export const SELECTION_MODE = { INCLUDE: 1, EXCLUDE: 0 };
